import { useCallback } from "react";

import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import DashboardService from "services/Dashboard";
import {
  invalidateCallMetricsTableQuery,
  useCallMetricsTable,
} from "hooks/useCallMetricsTable";
import { useCallDashboardFilters } from "@/routes/dashboard/useCallDashboardFilters";

export const CALL_METRICS_TABLE_CONSTANTS = {
  tableName: "call_metrics",
  queryKey: "call-metrics-table",
  exportTableName: "CallAgentMetricsTable",
  className: null,
  header: null,
  headerIcon: null,
};

const CallMetricsTableV3 = () => {
  const { columns } = useCallMetricsTable();
  const [queryFilters] = useCallDashboardFilters();

  const fetchCallMetrics = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await DashboardService.getAgentTable({
          ...nextQueryParams,
        });

        return response;
      } catch (error) {
        console.error("Error fetching call metrics:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      extraQueryParams={queryFilters}
      columns={columns}
      queryKey={CALL_METRICS_TABLE_CONSTANTS.queryKey}
      tableName={CALL_METRICS_TABLE_CONSTANTS.tableName}
      exportTableName={CALL_METRICS_TABLE_CONSTANTS.exportTableName}
      downloadParams={queryFilters}
      fetchData={fetchCallMetrics}
      invalidateData={invalidateCallMetricsTableQuery}
      enableSettings
    />
  );
};

export default CallMetricsTableV3;
